import type { Theme } from '@epilot/journey-elements'
import { useTheme } from '@epilot/journey-elements'
import useMediaQuery from '@material-ui/core/useMediaQuery'

export function IsScreenUnder(size: number) {
  const theme = useTheme<Theme>()

  return useMediaQuery(theme.breakpoints.down(size), {
    noSsr: true
  })
}

export function IsMobile() {
  const theme = useTheme<Theme>()

  return useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true
  })
}

export function IsMobileOrTablet() {
  const theme = useTheme<Theme>()

  return useMediaQuery(theme.breakpoints.down('sm'), {
    noSsr: true
  })
}

export const getBase64 = (file: File) =>
  new Promise((resolve) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error) => {
      console.error('Error: ', error)
    }
  })

export const isObject = (arg: unknown): arg is Record<string, unknown> => {
  return (
    typeof arg === 'object' &&
    !Array.isArray(arg) &&
    arg !== null &&
    !!Object.keys(arg)
  )
}
